export default __webpack_public_path__ + "static/media/ico.723cf8e1.svg";